// Wspólny słownik etykiet i kolorów dla pola `source` w shelter_updates.
// Pozwala uniknąć rozjazdu nazewnictwa między panelem admina, historią i panelem właściciela.

export type ShelterUpdateSource =
  | "public"
  | "quick_update"
  | "admin_edit"
  | "owner_edit"
  | "owner_profile_request";

export const SOURCE_LABELS: Record<ShelterUpdateSource, string> = {
  public: "Zgłoszenie publiczne",
  quick_update: "Szybka aktualizacja",
  admin_edit: "Zmiana administratora",
  owner_edit: "Zmiana z panelu",
  owner_profile_request: "Wniosek o zmianę danych",
};

// Klasy kolorów (Tailwind) dla badge'ów. Trzymamy w jednym miejscu, żeby było spójne.
export const SOURCE_BADGE_CLASS: Record<ShelterUpdateSource, string> = {
  admin_edit:
    "text-purple-600 border-purple-300/60 bg-purple-50/50 dark:bg-purple-950/20",
  owner_edit:
    "text-primary border-primary/40 bg-primary/5",
  owner_profile_request:
    "text-amber-700 dark:text-amber-300 border-amber-400/60 bg-amber-50/50 dark:bg-amber-950/20",
  public:
    "text-emerald-600 border-emerald-300/60 bg-emerald-50/50 dark:bg-emerald-950/20",
  quick_update:
    "text-emerald-600 border-emerald-300/60 bg-emerald-50/50 dark:bg-emerald-950/20",
};

export const sourceLabel = (source: string | null | undefined): string => {
  if (!source) return SOURCE_LABELS.public;
  return SOURCE_LABELS[source as ShelterUpdateSource] ?? source;
};

export const sourceBadgeClass = (source: string | null | undefined): string => {
  if (!source) return SOURCE_BADGE_CLASS.public;
  return SOURCE_BADGE_CLASS[source as ShelterUpdateSource] ?? SOURCE_BADGE_CLASS.public;
};
